import React, { useCallback, useEffect, useState, useContext } from "react";
import { useSnackbar } from "notistack";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  TextField,
  List,
  InputLabel,
  Select,
  MenuItem,
  ListItemButton,
  Container,
  Button,
  Box,
  Switch,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { Create, Replay } from "@mui/icons-material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import axios from "axios";

import Header from "../../components/Header";
import Waiter from "../../components/Backdrop";
import ConfirmModal from "../../components/ConfirmModal";

import SalvaLog from "../../utils/SalvaLog";

import Tabela from "./Tabela";

import "./styles.css";

import { api, baseUrl } from "../../services/Api";

import { Context as PermissoesContext } from "../../Context/PermissoesContext";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconDesativar from "../../assets/Icon-desativar.svg";

export default function AtualizacoesApp() {
  const { enqueueSnackbar } = useSnackbar();
  const { checarPermissao } = useContext(PermissoesContext);

  const [aba, setAba] = useState("Unidades");
  const [vetor, setVetor] = useState([]);
  const [espera, setEspera] = useState(false);
  const [filtroAtivo, setFiltroAtivo] = useState(true);
  const [abreOpcoes, setAbreOpcoes] = useState(false);
  const [abreUnidade, setAbreUnidade] = useState(false);
  const [visualizaUnidade, setVisualizaUnidade] = useState(false);
  const [abreExame, setAbreExame] = useState(false);
  const [visualizaExame, setVisualizaExame] = useState(false);
  const [confirmaExcluir, setConfirmaExcluir] = useState(false);
  const [confirmaDesativar, setConfirmaDesativar] = useState(false);
  const [confirmaAtivar, setConfirmaAtivar] = useState(false);

  const [atualizar, setAtualizar] = useState(false);

  const [id, setId] = useState("");

  const [unidade, setUnidade] = useState("");
  const [endereco, setEndereco] = useState("");
  const [pontoReferencia, setPontoReferencia] = useState("");
  const [horarioAtendimento, setHorarioAtendimento] = useState("");
  const [horarioColeta, setHorarioColeta] = useState("");
  const [telefone, setTelefone] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [kids, setKids] = useState("Não possui");
  const [foto, setFoto] = useState(null);
  const [conexao, setConexao] = useState(true);
  const [exibe_no_app, setExibe_no_app] = useState(true);
  const [observacoes, setObservacoes] = useState("");

  const [fotoAtual, setFotoAtual] = useState(null);
  const [arquivoImagem, setArquivoImagem] = useState(null);

  const [nome, setNome] = useState("");
  const [exames, setExames] = useState("");
  const [exame, setExame] = useState("");
  const [sinonimoExame, setSinonimoExame] = useState("");
  const [informacoesGerais, setInformacoesGerais] = useState("");
  const [material, setMaterial] = useState("");
  const [instrucoes, setInstrucoes] = useState("");
  const [entrega, setEntrega] = useState("");
  const [preAnalitico, setPreAnalitico] = useState("");
  const [mnemonico, setMnemonico] = useState("");
  const [processamentoDeAmostas, setProcessamentoDeAmostras] = useState("");
  const [volumeMinimo, setVolumeMinimo] = useState("");
  const [interferentesExames, setInterferentesExames] = useState("");
  const [arquivosAnexos, setArquivosAnexos] = useState([]);
  const [uploadedAnexos, setUploadedAnexos] = useState([]);

  // Estados para erros de validação
  const [errosExame, setErrosExame] = useState({});
  const [errosUnidade, setErrosUnidade] = useState({});

  useEffect(() => {
    async function iniciar() {
      try {
        setEspera(true);
        if (aba === "Unidades") {
          const resultadoUnidades = await api.get(`v2/geral/unidade`);
          setVetor(resultadoUnidades.data.unidade);
        } else {
          const resultadoExames = await api.get(
            `v2/geral/exame?ativo=${filtroAtivo}`
          );
          setVetor(resultadoExames.data.exame);
          setExames(resultadoExames.data.exame);
        }
      } catch (error) {
        enqueueSnackbar("Falha no carregamento de dados", { variant: "error" });
      }
      setEspera(false);
    }
    iniciar();
  }, [enqueueSnackbar, aba, atualizar, filtroAtivo]);

  const carregaImagem = async (e) => {
    e.preventDefault();
    if (e.target.files[0]) {
      setArquivoImagem(e.target.files[0]);
      setFotoAtual(URL.createObjectURL(e.target.files[0]));
    }
  };

  function cancelaUpload() {
    setArquivoImagem(null);
    setFotoAtual(null);
  }

  const upload = async (id_unidade) => {
    if (arquivoImagem) {
      setEspera(true);
      const formData = new FormData();
      formData.append("foto", arquivoImagem);

      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      try {
        const result = await axios.post(
          `${baseUrl}/api/uploadProxy`,
          formData,
          config
        );
        await api.put(`/v2/geral/uploadUnidade/${id_unidade}`, {
          foto: result.data,
        });
        SalvaLog(
          `Salvou foto da unidade de ID ${id_unidade}`,
          "Atualizações App"
        );
        enqueueSnackbar("Foto salva com sucesso", { variant: "success" });
        cancelaUpload();
      } catch (error) {
        enqueueSnackbar("Falha no carregamento da foto", { variant: "error" });
      }
      setEspera(false);
    }
  };

  function zeraUnidade() {
    setUnidade("");
    setEndereco("");
    setPontoReferencia("");
    setHorarioAtendimento("");
    setHorarioColeta("");
    setTelefone("");
    setId("");
    setLongitude("");
    setLatitude("");
    setKids("Não possui");
    setFoto(null);
    setConexao(true);
    setExibe_no_app(true);
    setObservacoes("");
  }

  async function adicionaUnidade() {
    setEspera(true);
    try {
      const informacoes = await api.get(`v2/geral/unidade/${id}`);
      setUnidade(informacoes.data.unidade.nome);
      setEndereco(informacoes.data.unidade.endereco);
      setPontoReferencia(informacoes.data.unidade.pontoreferencia);
      setHorarioAtendimento(informacoes.data.unidade.atendimento);
      setHorarioColeta(informacoes.data.unidade.horariocoleta);
      setTelefone(informacoes.data.unidade.telefone);
      setLongitude(informacoes.data.unidade.longitude);
      setLatitude(informacoes.data.unidade.latitude);
      setKids(informacoes.data.unidade.kids);
      setConexao(informacoes.data.unidade.conexao);
      setExibe_no_app(informacoes.data.unidade.exibe_no_app);
      setObservacoes(informacoes.data.unidade.observacoes);

      if (informacoes.data.unidade.foto) {
        setFoto(`${baseUrl}/${informacoes.data.unidade.foto}`);
      }
    } catch (error) {
      enqueueSnackbar("Falha no carregamento de dados", { variant: "error" });
    }
    setEspera(false);
  }

  async function salvaUnidade() {
    // Valida campos antes de salvar
    const validacao = validarUnidade();
    if (!validacao.valido) {
      enqueueSnackbar(validacao.erro, { variant: "error" });
      return;
    }

    if (unidade) {
      try {
        const dados = {
          nome: unidade.trim(),
          endereco,
          pontoreferencia: pontoReferencia,
          atendimento: horarioAtendimento,
          horariocoleta: horarioColeta,
          telefone,
          longitude,
          latitude,
          kids,
          conexao,
          exibe_no_app,
          observacoes,
        };
        if (id) {
          await api.put(`v2/geral/unidade/${id}`, dados);
          upload(id);

          enqueueSnackbar("Unidade atualizada", { variant: "success" });
        } else {
          const result = await api.post(`v2/geral/unidade`, dados);

          upload(result.data.unidade.id);

          enqueueSnackbar("Unidade adicionada", { variant: "success" });
        }
        setAtualizar((prevState) => !prevState);
      } catch (error) {
        console.error("Erro ao salvar unidade:", error);
        const errorMessage = error?.response?.data?.error || error?.response?.data?.message || error?.message || "Falha na operação";
        enqueueSnackbar(errorMessage, { variant: "error" });
      }
      cancelaUpload();
      zeraUnidade();
      setAbreUnidade(false);
    } else {
      enqueueSnackbar("Nome da unidade está vazio", { variant: "warning" });
    }
  }
  function zeraExame() {
    setExame("");
    setSinonimoExame("");
    setInformacoesGerais("");
    setMaterial("");
    setInstrucoes("");
    setPreAnalitico("");
    setMnemonico("");
    setProcessamentoDeAmostras("");
    setVolumeMinimo("");
    setInterferentesExames("");
    setEntrega("");
    setId("");
    setUploadedAnexos([]);
    setArquivosAnexos([]);
    setErrosExame({});
  }

  // Validação de campos do exame antes de salvar
  const validarExame = () => {
    const erros = {};

    if (!exame || exame.trim() === "") {
      erros.nome = "O nome do exame é obrigatório";
    } else if (exame.length > 255) {
      erros.nome = "Nome do exame excede o limite de 255 caracteres";
    }

    if (material && material.length > 255) {
      erros.material = "Material excede o limite de 255 caracteres";
    }

    if (entrega && entrega.length > 255) {
      erros.entrega = "Entrega excede o limite de 255 caracteres";
    }

    if (mnemonico && mnemonico.length > 20) {
      erros.mnemonico = "Mnemônico excede o limite de 20 caracteres";
    }

    if (volumeMinimo && volumeMinimo.length > 255) {
      erros.volumeMinimo = "Volume mínimo excede o limite de 255 caracteres";
    }

    setErrosExame(erros);
    const temErros = Object.keys(erros).length > 0;
    
    // Retorna o primeiro erro junto com o resultado da validação
    if (temErros) {
      const primeiroErro = Object.values(erros).find(erro => erro);
      return { valido: false, erro: primeiroErro || "Erro de validação" };
    }
    
    return { valido: true };
  };

  // Validação de campos da unidade antes de salvar
  const validarUnidade = () => {
    const erros = {};

    if (!unidade || unidade.trim() === "") {
      erros.nome = "O nome da unidade é obrigatório";
    } else if (unidade.length > 255) {
      erros.nome = "Nome da unidade excede o limite de 255 caracteres";
    }

    if (endereco && endereco.length > 255) {
      erros.endereco = "Endereço excede o limite de 255 caracteres";
    }

    if (pontoReferencia && pontoReferencia.length > 255) {
      erros.pontoReferencia = "Ponto de referência excede o limite de 255 caracteres";
    }

    if (horarioAtendimento && horarioAtendimento.length > 255) {
      erros.horarioAtendimento = "Horário de atendimento excede o limite de 255 caracteres";
    }

    if (horarioColeta && horarioColeta.length > 255) {
      erros.horarioColeta = "Horário de coleta excede o limite de 255 caracteres";
    }

    if (telefone && telefone.length > 255) {
      erros.telefone = "Telefone excede o limite de 255 caracteres";
    }

    if (kids && kids.length > 255) {
      erros.kids = "Kids excede o limite de 255 caracteres";
    }

    if (observacoes && observacoes.length > 255) {
      erros.observacoes = "Observações excede o limite de 255 caracteres";
    }

    setErrosUnidade(erros);
    const temErros = Object.keys(erros).length > 0;
    
    // Retorna o primeiro erro junto com o resultado da validação
    if (temErros) {
      const primeiroErro = Object.values(erros).find(erro => erro);
      return { valido: false, erro: primeiroErro || "Erro de validação" };
    }
    
    return { valido: true };
  };

  const procuraExames = useCallback(
    async (nome_filtro) => {
      setNome(nome_filtro);
      const filtro = exames.filter((ex) => ex.nome.includes(nome_filtro));
      setVetor(filtro);
    },
    [exames]
  );

  async function adicionaExame() {
    setEspera(true);
    try {
      const informacoes = await api.get(`v2/geral/exame/${id}`);

      setExame(informacoes.data.exame.nome);
      setSinonimoExame(informacoes.data.exame.sinonimoExame);
      setInformacoesGerais(informacoes.data.exame.informacoesGerais);
      setMaterial(informacoes.data.exame.material);
      setInstrucoes(informacoes.data.exame.instrucoes);
      setEntrega(informacoes.data.exame.entrega);
      setPreAnalitico(informacoes.data.exame.preAnalitico);
      setMnemonico(informacoes.data.exame.mnemonico);
      setProcessamentoDeAmostras(informacoes.data.exame.processamentoDeAmostas);
      setVolumeMinimo(informacoes.data.exame.volumeMinimo);
      setInterferentesExames(informacoes.data.exame.interferentesExames);

      await buscaAnexos(id);
    } catch (error) {
      enqueueSnackbar("Falha no carregamento de dados", { variant: "error" });
    }
    setEspera(false);
  }

  async function salvaExame() {
    // Valida campos antes de salvar
    const validacao = validarExame();
    if (!validacao.valido) {
      enqueueSnackbar(validacao.erro, { variant: "error" });
      return;
    }

    try {
      let exameSalvo;

      if (id) {
        // Atualiza exame
        await api.put(`/v2/geral/exame/${id}`, {
          nome: exame.toUpperCase().trim(),
          sinonimoExame,
          informacoesGerais,
          material,
          instrucoes,
          entrega,
          preAnalitico,
          mnemonico: mnemonico?.trim() ? mnemonico.toUpperCase().trim() : mnemonico,
          processamentoDeAmostas,
          volumeMinimo,
          interferentesExames,
        });
        exameSalvo = { id }; // Mantém o id atual
        enqueueSnackbar("Exame atualizado", { variant: "success" });
      } else {
        // Cria novo exame
        const { data } = await api.post(`/v2/geral/exame`, {
          nome: exame.toUpperCase().trim(),
          sinonimoExame,
          informacoesGerais,
          material,
          instrucoes,
          entrega,
          preAnalitico,
          mnemonico: mnemonico?.trim() ? mnemonico.toUpperCase().trim() : mnemonico,
          processamentoDeAmostas,
          volumeMinimo,
          interferentesExames,
        });
        exameSalvo = data.exame;
        enqueueSnackbar("Exame adicionado", { variant: "success" });
      }

      if (arquivosAnexos.length > 0) {
        try {
          const exameIdParaAnexos = exameSalvo.id || id;
          if (!exameIdParaAnexos) {
            throw new Error("ID do exame não encontrado");
          }

          await Promise.all(
            arquivosAnexos.map(async (arquivo) => {
              const formData = new FormData();
              formData.append("file", arquivo);
              formData.append("exame_id", exameIdParaAnexos);
              const response = await api.post("/v2/geral/anexos", formData, {
                headers: { "Content-Type": "multipart/form-data" },
              });
              return response.data;
            })
          );
          
          enqueueSnackbar("Anexos enviados com sucesso", { variant: "success" });
          
          // Limpa os arquivos temporários e recarrega os anexos salvos
          setArquivosAnexos([]);
          await buscaAnexos(exameIdParaAnexos);
        } catch (uploadError) {
          console.error("Erro no upload dos anexos:", uploadError);
          const errorMessage = uploadError?.response?.data?.error || uploadError?.message || "Erro desconhecido";
          enqueueSnackbar(`Erro ao enviar anexos: ${errorMessage}`, { variant: "error" });
        }
      }

      setAtualizar((prev) => !prev);
      zeraExame();
      setAbreExame(false);
    } catch (error) {
      console.error("Erro ao salvar exame:", error);
      const errorMessage = error?.response?.data?.error || error?.response?.data?.message || error?.message || "Falha na operação";
      enqueueSnackbar(errorMessage, { variant: "error" });
    }
  }

  async function desativarExame() {
    setEspera(true);
    try {
      await api.put(`/v2/geral/exame/${id}/desativar`);
      setAtualizar((prevState) => !prevState);
      enqueueSnackbar("Exame desativado com sucesso", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar("Não foi possível desativar o exame", {
        variant: "error",
      });
    }
    setEspera(false);
    setId("");
    setConfirmaDesativar(false);
  }

  async function ativarExame() {
    setEspera(true);
    try {
      await api.put(`/v2/geral/exame/${id}/ativar`);
      setAtualizar((prevState) => !prevState);
      enqueueSnackbar("Exame ativado com sucesso", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar("Não foi possível ativar o exame", {
        variant: "error",
      });
    }
    setEspera(false);
    setId("");
    setConfirmaAtivar(false);
  }

  function cancelaDesativacao() {
    setId("");
    setConfirmaDesativar(false);
  }

  function cancelaAtivacao() {
    setId("");
    setConfirmaAtivar(false);
  }


  function cancelaExclusao() {
    setId("");
    setConfirmaExcluir(false);
  }

  async function ativaExclusao() {
    setEspera(true);
    try {
      if (aba === "Unidades") {
        await api.delete(`v2/geral/unidade/${id}`);
      } else {
        await api.delete(`v2/geral/exame/${id}`);
      }
      setAtualizar((prevState) => !prevState);
      enqueueSnackbar(
        `${aba === "Unidades" ? "Unidade excluída" : "Exame excluído"}`,
        {
          variant: "success",
        }
      );
    } catch (error) {
      enqueueSnackbar(
        `Não foi possível excluir ${
          aba === "Unidades" ? " a unidade" : " o exame"
        }`,
        { variant: "error" }
      );
    }
    setEspera(false);
    setId("");
    setConfirmaExcluir(false);
  }

  const buscaAnexos = async (exameId) => {
    try {
      const { data } = await api.get(`/v2/geral/anexos/${exameId}`);

      // Busca todos os anexos ativos
      const ativos = Array.isArray(data.anexo)
        ? data.anexo.filter((a) => a.ativo)
        : [];

      if (ativos.length > 0) {
        setUploadedAnexos(ativos);
      } else {
        setUploadedAnexos([]);
      }
    } catch (error) {
      console.error("Erro ao buscar anexo:", error);
      setUploadedAnexos([]);
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);  // Pega todos os arquivos
    if (files.length > 0) {
      setArquivosAnexos(prev => [...prev, ...files]);  // Adiciona aos existentes
    }
  };
  const handleView = (anexo) => {
    // anexo pode ser um objeto do servidor ou um File
    if (anexo?.id) {
      window.open(`${process.env.REACT_APP_BASEURL_WEB}/v2/geral/anexos/baixar/${anexo.id}`, "_blank");
    } else if (anexo instanceof File) {
      const blobUrl = URL.createObjectURL(anexo);
      window.open(blobUrl, "_blank");
    }
  };

  const handleDelete = async (anexo) => {
    // Se for arquivo local
    if (anexo instanceof File) {
      setArquivosAnexos(prev => prev.filter(f => f !== anexo));
      return;
    }
    
    // Se for anexo do servidor
    if (anexo?.id) {
      try {
        await api.delete(`/v2/geral/anexos/${anexo.id}`);
        setUploadedAnexos(prev => prev.filter(a => a.id !== anexo.id));
        enqueueSnackbar("Anexo excluído com sucesso", {
          variant: "success",
        });
      } catch (error) {
        console.error("Erro ao excluir anexo:", error);
        enqueueSnackbar("Falha ao excluir anexo", {
          variant: "error",
        });
      }
    }
  };

  return (
    <>
      <Header titulo="Atualizações App" />
      <Container>
        <div id="container-aba-ctrl-samples">
          <button
            type="button"
            id={
              aba === "Unidades" ? "button-aba-ctrl-samples-selected" : "Aba1"
            }
            className="button-aba-ctrl-samples"
            onClick={() => {
              setAba("Unidades");
            }}
          >
            Unidades
          </button>
          <button
            type="button"
            id={aba === "Exames" ? "button-aba-ctrl-samples-selected" : "Aba1"}
            className="button-aba-ctrl-samples"
            onClick={() => {
              setAba("Exames");
            }}
          >
            Exames
          </button>
        </div>
        <div id="content-form-ctrl-samples">
          <div className="container-botao-switch">
            <button
              className="btnAgendar"
              type="button"
              onClick={() => {
                if (checarPermissao("AAP002")) {
                  if (aba === "Unidades") {
                    setAbreUnidade(true);
                  } else {
                    setAbreExame(true);
                  }
                } else {
                  enqueueSnackbar(
                    `Você não possui autorização para criar ${
                      aba === "Unidades" ? " unidades" : " exames"
                    }`,
                    { variant: "error" }
                  );
                }
              }}
            >
              Adicionar
            </button>

            {aba === "Exames" && (
              <FormControlLabel
                className="switch-filtro"
                control={
                  <Switch
                    checked={!filtroAtivo}
                    onChange={(e) => {
                      setFiltroAtivo(!e.target.checked);
                      setNome(""); // Limpa a pesquisa ao trocar o filtro
                    }}
                    color="primary"
                  />
                }
                label={!filtroAtivo ? "Mostrar Exames Desativados" : "Mostrar Exames Desativados"}
              />
            )}
          </div>

          {aba === "Exames" ? (
            <div className="pesquisa">
              <TextField
                label="Pesquisar"
                placeholder="Informe o nome do exame"
                InputLabelProps={{
                  shrink: true,
                }}
                variant="outlined"
                onChange={(e) => procuraExames(e.target.value.toUpperCase())}
                value={nome}
              />
            </div>
          ) : null}
        </div>

        <Tabela vetor={vetor} setId={setId} setAbreOpcoes={setAbreOpcoes} />

        <Waiter espera={espera} />

        <Dialog
          open={abreOpcoes}
          onClose={() => setAbreOpcoes(false)}
          aria-labelledby="simple-dialog-title"
        >
          <DialogTitle id="selecionaOpcao">Selecione uma opção</DialogTitle>
          <List className="opList">
            <ListItemButton
              key="102"
              onClick={() => {
                if (aba === "Unidades") {
                  adicionaUnidade();
                  setVisualizaUnidade(true);
                } else {
                  adicionaExame();
                  setVisualizaExame(true);
                }

                setAbreOpcoes(false);
              }}
            >
              <VisibilityIcon color="primary" />
              <InputLabel id="itemLista"> Visualizar</InputLabel>
            </ListItemButton>
            <ListItemButton
              key="101"
              onClick={() => {
                if (checarPermissao("AAP004")) {
                  if (aba === "Unidades") {
                    adicionaUnidade();
                    setAbreUnidade(true);
                  } else {
                    adicionaExame();
                    setAbreExame(true);
                  }
                } else {
                  enqueueSnackbar(
                    `Você não possui autorização para editar ${
                      aba === "Unidades" ? " unidades" : " exames"
                    }`,
                    { variant: "error" }
                  );
                }

                setAbreOpcoes(false);
              }}
            >
              <Create color="primary" />
              <InputLabel id="itemLista"> Editar</InputLabel>
            </ListItemButton>

            {aba === "Exames" && (
              <>
                {filtroAtivo ? (
                  <ListItemButton
                    key="104"
                    onClick={() => {
                      setAbreOpcoes(false);
                      if (checarPermissao("AAP004")) {
                        setConfirmaDesativar(true);
                      } else {
                        enqueueSnackbar(
                          `Você não possui autorização para desativar exames`,
                          { variant: "error" }
                        );
                      }
                    }}
                  >
                    <img src={IconDesativar} alt="Desativar" style={{ width: 24, height: 24 }} />
                    <InputLabel id="itemLista"> Desativar</InputLabel>
                  </ListItemButton>
                ) : (
                  <ListItemButton
                    key="105"
                    onClick={() => {
                      setAbreOpcoes(false);
                      if (checarPermissao("AAP004")) {
                        setConfirmaAtivar(true);
                      } else {
                        enqueueSnackbar(
                          `Você não possui autorização para ativar exames`,
                          { variant: "error" }
                        );
                      }
                    }}
                  >
                    <PlayCircleIcon sx={{ color: "#003399" }} />
                    <InputLabel id="itemLista"> Ativar</InputLabel>
                  </ListItemButton>
                )}
              </>
            )}

            <ListItemButton
              key="103"
              onClick={() => {
                setAbreOpcoes(false);
                if (checarPermissao("AAP004")) {
                  setConfirmaExcluir(true);
                } else {
                  enqueueSnackbar(
                    `Você não possui autorização para excluir ${
                      aba === "Unidades" ? " unidades" : " exames"
                    }`,
                    { variant: "error" }
                  );
                }
              }}
            >
              <DeleteForeverIcon color="error" />
              <InputLabel id="itemLista"> Excluir</InputLabel>
            </ListItemButton>

            <ListItemButton key="106" onClick={() => setAbreOpcoes(false)}>
              <Replay />
              <InputLabel id="itemLista"> Voltar</InputLabel>
            </ListItemButton>
          </List>
        </Dialog>

        <Dialog
          open={abreUnidade}
          fullWidth
          maxWidth="md"
          onClose={() => {
            setAbreUnidade(false);
            zeraUnidade();
          }}
        >
          <DialogTitle id="alert-dialog-title">
            {id ? "Informações da" : "Nova "} Unidade
          </DialogTitle>
          <div className="container-information-unit">
            <div className="content-information-unit-image">
              <img
                id="img-unidade-foto"
                className="imgUnidade"
                src={
                  fotoAtual ||
                  foto ||
                  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0su1iftTQ4Q14MqUMUjR4Gl1jgnY04yIqnfJifb5ArKJltmgUJ7pzzNzbnw9krJU-7Ok&usqp=CAU"
                }
                alt="Unidade DNA Center"
              />
              {!fotoAtual ? (
                <label id="btn-unidade-foto" htmlFor="foto">
                  Alterar
                  <input
                    type="file"
                    id="foto"
                    name="foto"
                    accept="image/png, image/jpeg"
                    onChange={carregaImagem}
                  />
                </label>
              ) : (
                <button
                  type="button"
                  id="btn-cancel-update-photo"
                  onClick={() => cancelaUpload()}
                >
                  Cancelar
                </button>
              )}
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Unidade"
                value={unidade}
                maxLength={255}
                error={!!errosUnidade.nome}
                helperText={errosUnidade.nome}
                onChange={(e) => {
                  e.preventDefault();
                  setUnidade(e.target.value);
                }}
              />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Endereço"
                value={endereco}
                maxLength={255}
                error={!!errosUnidade.endereco}
                helperText={errosUnidade.endereco}
                onChange={(e) => {
                  e.preventDefault();
                  setEndereco(e.target.value);
                }}
              />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Ponto de Referência"
                value={pontoReferencia}
                maxLength={255}
                error={!!errosUnidade.pontoReferencia}
                helperText={errosUnidade.pontoReferencia}
                onChange={(e) => {
                  e.preventDefault();
                  setPontoReferencia(e.target.value);
                }}
              />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Horário de Atendimento"
                value={horarioAtendimento}
                maxLength={255}
                error={!!errosUnidade.horarioAtendimento}
                helperText={errosUnidade.horarioAtendimento}
                onChange={(e) => {
                  e.preventDefault();
                  setHorarioAtendimento(e.target.value);
                }}
              />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Horário de Coleta"
                value={horarioColeta}
                maxLength={255}
                error={!!errosUnidade.horarioColeta}
                helperText={errosUnidade.horarioColeta}
                onChange={(e) => {
                  e.preventDefault();
                  setHorarioColeta(e.target.value);
                }}
              />
            </div>
            <div className="content-information-unit-short">
              <div className="content-information-unit">
                <TextField
                  label="Telefone"
                  value={telefone}
                  maxLength={255}
                  error={!!errosUnidade.telefone}
                  helperText={errosUnidade.telefone}
                  onChange={(e) => {
                    e.preventDefault();
                    setTelefone(e.target.value);
                  }}
                />
              </div>
              <div className="content-information-unit">
                <TextField
                  label="Latitude"
                  value={latitude}
                  onChange={(e) => {
                    e.preventDefault();
                    setLatitude(e.target.value);
                  }}
                />
              </div>
              <div className="content-information-unit">
                <TextField
                  label="Longitude"
                  value={longitude}
                  onChange={(e) => {
                    e.preventDefault();
                    setLongitude(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="content-information-unit-short">
              <div className="content-information-unit">
                <InputLabel id="demo-simple-select-label">
                  Possui Kids?
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={kids}
                  onChange={(e) => setKids(e.target.value)}
                  style={{ width: 180 }}
                >
                  <MenuItem value="Não possui">Não possui</MenuItem>
                  <MenuItem value="Espaço Kids">Espaço Kids</MenuItem>
                  <MenuItem value="Sala de Coleta Kids">
                    Sala de Coleta Kids
                  </MenuItem>
                  <MenuItem value="Espaço Kids/Sala de Coleta Kids">
                    Espaço Kids/Sala de Coleta Kids
                  </MenuItem>
                </Select>
              </div>
              <div className="content-information-unit">
                <input
                  id="exibe_no_app"
                  className="input-check-samples"
                  type="checkbox"
                  checked={exibe_no_app}
                  onClick={() => {
                    setExibe_no_app((prevState) => !prevState);
                  }}
                />
                <span
                  id="label-exibe_no_app"
                  className="label-add-samples"
                  htmlFor="exibe_no_app"
                >
                  {" Exibe no App/Site"}
                </span>
              </div>
              <div className="content-information-unit">
                <input
                  id="conexao"
                  className="input-check-samples"
                  type="checkbox"
                  checked={conexao}
                  onClick={() => {
                    setConexao((prevState) => !prevState);
                  }}
                />
                <span
                  id="label-Conexao"
                  className="label-add-samples"
                  htmlFor="Conexao"
                >
                  {" Exibe no Conexão"}
                </span>
              </div>
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                multiline
                minRows={3}
                maxRows={6}
                label="Observações"
                placeholder="Ex: não atendemos UNIMED nessa unidade"
                value={observacoes}
                onChange={(e) => {
                  e.preventDefault();
                  setObservacoes(e.target.value);
                }}
              />
            </div>
          </div>

          <DialogActions>
            <button
              type="button"
              className="btnDialogs"
              onClick={() => salvaUnidade()}
            >
              Salvar
            </button>
            <button
              type="button"
              className="btnDialogs"
              onClick={() => {
                setAbreUnidade(false);
                zeraUnidade();
              }}
            >
              Cancelar
            </button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={visualizaUnidade}
          fullWidth
          maxWidth="md"
          onClose={() => {
            setVisualizaUnidade(false);
            zeraUnidade();
          }}
        >
          <DialogTitle id="alert-dialog-title">
            {id ? "Informações da" : "Nova "} Unidade
          </DialogTitle>
          <div className="container-information-unit">
            <div className="content-information-unit-image">
              <img
                id="img-unidade-foto"
                className="imgUnidade"
                src={
                  fotoAtual ||
                  foto ||
                  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0su1iftTQ4Q14MqUMUjR4Gl1jgnY04yIqnfJifb5ArKJltmgUJ7pzzNzbnw9krJU-7Ok&usqp=CAU"
                }
                alt="Unidade DNA Center"
              />
            </div>
            <div className="content-information-unit">
              <TextField fullWidth label="Unidade" value={unidade} disabled />
            </div>
            <div className="content-information-unit">
              <TextField fullWidth label="Endereço" value={endereco} disabled />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Ponto de Referência"
                value={pontoReferencia}
                disabled
              />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Horário de Atendimento"
                value={horarioAtendimento}
                disabled
              />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Horário de Coleta"
                value={horarioColeta}
                disabled
              />
            </div>
            <div className="content-information-unit-short">
              <div className="content-information-unit">
                <TextField label="Telefone" value={telefone} disabled />
              </div>
              <div className="content-information-unit">
                <TextField label="Latitude" value={latitude} disabled />
              </div>
              <div className="content-information-unit">
                <TextField label="Longitude" value={longitude} disabled />
              </div>
            </div>
            <div className="content-information-unit-short">
              <div className="content-information-unit">
                <InputLabel id="demo-simple-select-label">
                  Possui Kids?
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={kids}
                  disabled
                >
                  <MenuItem value="Não possui">Não possui</MenuItem>
                  <MenuItem value="Espaço Kids">Espaço Kids</MenuItem>
                  <MenuItem value="Sala de Coleta Kids">
                    Sala de Coleta Kids
                  </MenuItem>
                  <MenuItem value="Espaço Kids/Sala de Coleta Kids">
                    Espaço Kids/Sala de Coleta Kids
                  </MenuItem>
                </Select>
              </div>
              <div className="content-information-unit">
                <input
                  id="exibe_no_app"
                  className="input-check-samples"
                  type="checkbox"
                  checked={exibe_no_app}
                  disabled
                />
                <span
                  id="label-exibe_no_app"
                  className="label-add-samples"
                  htmlFor="exibe_no_app"
                >
                  {" Exibe no App/Site"}
                </span>
              </div>
              <div className="content-information-unit">
                <input
                  id="conexao"
                  className="input-check-samples"
                  type="checkbox"
                  checked={conexao}
                  disabled
                />
                <span
                  id="label-Conexao"
                  className="label-add-samples"
                  htmlFor="Conexao"
                >
                  {" Exibe no Conexão"}
                </span>
              </div>
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                multiline
                minRows={3}
                maxRows={6}
                label="Observações"
                placeholder="Ex: não atendemos UNIMED nessa unidade"
                value={observacoes}
                disabled
                InputProps={{
                  style: { whiteSpace: 'pre-line' }
                }}
              />
            </div>
          </div>

          <DialogActions>
            <button
              type="button"
              className="btnDialogs"
              onClick={() => {
                setVisualizaUnidade(false);
                zeraUnidade();
              }}
            >
              Voltar
            </button>
          </DialogActions>
        </Dialog>

        <Dialog // Exame
          open={abreExame}
          fullWidth
          maxWidth="md"
          onClose={() => {
            setAbreExame(false);
            zeraExame();
          }}
        >
          <DialogTitle id="alert-dialog-title">
            {id ? "Informações do" : "Novo "} Exame
          </DialogTitle>
          <div className="container-information-unit">
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Nome do Exame"
                placeholder="Ex: Hemograma Completo"
                value={exame}
                maxLength={255}
                error={!!errosExame.nome}
                helperText={errosExame.nome}
                onChange={(e) => {
                  e.preventDefault();
                  setExame(e.target.value);
                }}
              />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Sinônimos"
                placeholder="Ex: CBC, Hemograma"
                value={sinonimoExame}
                onChange={(e) => {
                  e.preventDefault();
                  setSinonimoExame(e.target.value);
                }}
              />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                multiline
                minRows={3}
                maxRows={10}
                label="Informações Gerais"
                placeholder="Informações básicas sobre o exame"
                value={informacoesGerais}
                onChange={(e) => {
                  e.preventDefault();
                  setInformacoesGerais(e.target.value);
                }}
              />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Material"
                placeholder="Ex: Sangue total EDTA, Urina"
                value={material}
                maxLength={255}
                error={!!errosExame.material}
                helperText={errosExame.material}
                onChange={(e) => {
                  e.preventDefault();
                  setMaterial(e.target.value);
                }}
              />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                multiline
                minRows={3}
                maxRows={10}
                label="Instruções de preparo e coleta"
                placeholder="Instruções sobre o exame"
                value={instrucoes}
                error={!!errosExame.instrucoes}
                helperText={errosExame.instrucoes}
                onChange={(e) => {
                  e.preventDefault();
                  setInstrucoes(e.target.value);
                }}
              />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Entrega"
                placeholder="Ex: 24 horas, 48 horas"
                value={entrega}
                maxLength={255}
                error={!!errosExame.entrega}
                helperText={errosExame.entrega}
                onChange={(e) => {
                  e.preventDefault();
                  setEntrega(e.target.value);
                }}
              />
            </div>
            <div className="content-information-unit">
              <InputLabel style={{ marginTop: '16px', marginBottom: '8px', fontWeight: 'bold', color: '#1E55AF' }}>
                Informações internas:
              </InputLabel>
            </div>
            <div className="content-information-unit-short">
              <div className="content-information-unit" style={{ flex: '3' }}>
                <TextField
                  fullWidth
                  label="Pré-analítico"
                  placeholder="Informações para processamento interno"
                  value={preAnalitico}
                  onChange={(e) => {
                    e.preventDefault();
                    setPreAnalitico(e.target.value);
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#BFD7FE',
                    }
                  }}
                />
              </div>
              <div className="content-information-unit" style={{ flex: '1', marginLeft: '16px' }}>
                <TextField
                  fullWidth
                  label="Mnemônico"
                  placeholder="Ex: HEM"
                  value={mnemonico}
                  maxLength={20}
                  error={!!errosExame.mnemonico}
                  helperText={errosExame.mnemonico}
                  onChange={(e) => {
                    e.preventDefault();
                    setMnemonico(e.target.value);
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#BFD7FE',
                    }
                  }}
                />
              </div>
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Processamento de amostras"
                placeholder="Procedimentos de laboratório"
                value={processamentoDeAmostas}
                onChange={(e) => {
                  e.preventDefault();
                  setProcessamentoDeAmostras(e.target.value);
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#BFD7FE',
                  }
                }}
              />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Volume mínimo"
                placeholder="Ex: 5mL, 10mL"
                value={volumeMinimo}
                maxLength={255}
                error={!!errosExame.volumeMinimo}
                helperText={errosExame.volumeMinimo}
                onChange={(e) => {
                  e.preventDefault();
                  setVolumeMinimo(e.target.value);
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#BFD7FE',
                  }
                }}
              />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Interferentes dos exames"
                placeholder="Ex: Medicamentos, alimentos"
                value={interferentesExames}
                onChange={(e) => {
                  e.preventDefault();
                  setInterferentesExames(e.target.value);
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#BFD7FE',
                  }
                }}
              />
            </div>
            <Box mt={2}>
              {/* Lista de anexos já salvos */}
              {uploadedAnexos.map((anexo) => (
                <Box key={anexo.id} display="flex" justifyContent="center" gap={2} mb={1}>
                  <Typography variant="body2" sx={{ alignSelf: 'center', color: '#000' }}>
                    {anexo.nome_arquivo}
                  </Typography>
                  <Button variant="outlined" size="small" onClick={() => handleView(anexo)}>
                    Visualizar
                  </Button>
                  <Button variant="outlined" color="error" size="small" onClick={() => handleDelete(anexo)}>
                    Excluir
                  </Button>
                </Box>
              ))}
              
              {/* Lista de arquivos ainda não enviados */}
              {arquivosAnexos.map((arquivo, index) => (
                <Box key={`new-${index}`} display="flex" justifyContent="center" gap={2} mb={1}>
                  <Typography variant="body2" sx={{ alignSelf: 'center', color: '#000' }}>
                    {arquivo.name}
                  </Typography>
                  <Button variant="outlined" size="small" onClick={() => handleView(arquivo)}>
                    Visualizar
                  </Button>
                  <Button variant="outlined" color="error" size="small" onClick={() => handleDelete(arquivo)}>
                    Excluir
                  </Button>
                </Box>
              ))}
              
              {/* Botão para adicionar mais */}
              <Box display="flex" justifyContent="center" mt={2}>
                <Button variant="contained" component="label">
                  {uploadedAnexos.length === 0 && arquivosAnexos.length === 0 ? "Anexar documento" : "Adicionar mais documentos"}
                  <input type="file" multiple hidden onChange={handleFileChange} />
                </Button>
              </Box>
            </Box>
          </div>

          <DialogActions>
            <button
              type="button"
              className="btnDialogs"
              onClick={() => {
                salvaExame();
              }}
            >
              Salvar
            </button>
            <button
              type="button"
              className="btnDialogs"
              onClick={() => {
                setAbreExame(false);
                zeraExame();
              }}
            >
              Cancelar
            </button>
          </DialogActions>
        </Dialog>
        <Dialog // Visualizar Exame
          open={visualizaExame}
          fullWidth
          maxWidth="md"
          onClose={() => {
            setVisualizaExame(false);
            zeraExame();
          }}
        >
          <DialogTitle id="alert-dialog-title">
            {id ? "Informações do" : "Novo "} Exame
          </DialogTitle>
          <div className="container-information-unit">
            <div className="content-information-unit">
              <TextField fullWidth label="Exame" placeholder="Ex: Hemograma Completo" value={exame} disabled />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Sinônimos"
                placeholder="Ex: CBC, Hemograma"
                value={sinonimoExame}
                disabled
              />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Informações Gerais"
                placeholder="Informações básicas sobre o exame"
                value={informacoesGerais}
                disabled
              />
            </div>
            <div className="content-information-unit">
              <TextField fullWidth label="Material" placeholder="Ex: Sangue total EDTA, Urina" value={material} disabled />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                multiline
                minRows={3}
                maxRows={10}
                label="Instruções de preparo e coleta"
                placeholder="Instruções sobre o exame"
                value={instrucoes}
                disabled
                InputProps={{
                  style: { whiteSpace: 'pre-line' }
                }}
              />
            </div>
            <div className="content-information-unit">
              <TextField fullWidth label="Entrega" placeholder="Ex: 24 horas, 48 horas" value={entrega} disabled />
            </div>
            <div className="content-information-unit">
              <InputLabel style={{ marginTop: '16px', marginBottom: '8px', fontWeight: 'bold', color: '#1E55AF' }}>
                Informações internas:
              </InputLabel>
            </div>
            <div className="content-information-unit-short">
              <div className="content-information-unit" style={{ flex: '3' }}>
                <TextField
                  fullWidth
                  label="Pré-analítico"
                  placeholder="Informações para processamento interno"
                  value={preAnalitico}
                  disabled
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#BFD7FE',
                    }
                  }}
                />
              </div>
              <div className="content-information-unit" style={{ flex: '1', marginLeft: '16px' }}>
                <TextField
                  fullWidth
                  label="Mnemônico"
                  placeholder="Ex: HEM"
                  value={mnemonico}
                  disabled
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#BFD7FE',
                    }
                  }}
                />
              </div>
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Processamento de amostras"
                placeholder="Procedimentos de laboratório"
                value={processamentoDeAmostas}
                disabled
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#BFD7FE',
                  }
                }}
              />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Volume mínimo"
                placeholder="Ex: 5mL, 10mL"
                value={volumeMinimo}
                disabled
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#BFD7FE',
                  }
                }}
              />
            </div>
            <div className="content-information-unit">
              <TextField
                fullWidth
                label="Interferentes dos exames"
                placeholder="Ex: Medicamentos, alimentos"
                value={interferentesExames}
                disabled
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#BFD7FE',
                  }
                }}
              />
            </div>
            {uploadedAnexos.length > 0 ? (
              <Box mt={2}>
                {uploadedAnexos.map((anexo) => (
                  <Box key={anexo.id} display="flex" justifyContent="center" gap={2} mb={1}>
                    <Typography variant="body2" sx={{ alignSelf: 'center', color: '#000' }}>
                      {anexo.nome_arquivo}
                    </Typography>
                    <Button variant="outlined" size="small" onClick={() => handleView(anexo)}>
                      Visualizar documento
                    </Button>
                  </Box>
                ))}
              </Box>
            ) : (
              <Box display="flex" justifyContent="center" mt={2}>
                <Typography variant="body2" color="text.secondary">
                  Nenhum documento anexado
                </Typography>
              </Box>
            )}
          </div>
          <DialogActions>
            <button
              type="button"
              className="btnDialogs"
              onClick={() => {
                setVisualizaExame(false);
              }}
            >
              Voltar
            </button>
          </DialogActions>
        </Dialog>

        {/* modal de confirmação de exclusão */}
        <ConfirmModal
          open={confirmaExcluir}
          onClose={() => cancelaExclusao()}
          title={`Você realmente deseja excluir ${
            aba === "Unidades" ? "esta unidade" : "este exame"
          }?`}
          text="Esta ação não pode ser desfeita."
          onCancel={() => cancelaExclusao()}
          onConfirm={() => ativaExclusao()}
          cancelButtonLabel="Cancelar"
          confirmButtonLabel="Confirmar"
        />

        {/* modal de confirmação de desativação */}
        <ConfirmModal
          open={confirmaDesativar}
          onClose={() => cancelaDesativacao()}
          title="Você realmente deseja desativar este exame?"
          text="Ao desativar, ele não será mais exibido no site. Você poderá reativá-lo posteriormente."
          onCancel={() => cancelaDesativacao()}
          onConfirm={() => desativarExame()}
          cancelButtonLabel="Cancelar"
          confirmButtonLabel="Confirmar"
        />

        {/* modal de confirmação de ativação */}
        <ConfirmModal
          open={confirmaAtivar}
          onClose={() => cancelaAtivacao()}
          title="Você realmente deseja ativar este exame?"
          text="Ao ativar, ele voltará a ser exibido no site para os usuários."
          onCancel={() => cancelaAtivacao()}
          onConfirm={() => ativarExame()}
          cancelButtonLabel="Cancelar"
          confirmButtonLabel="Confirmar"
        />
      </Container>
    </>
  );
}
